
<div appBreakpointClasses style="height: 95vh; width: 95vw; margin: 0 auto;">
    <app-slider [contents]="projects" [config]="pageConfig"></app-slider>
</div>